import React, { useRef, useState } from 'react'
import styles from './index.module.css'
import { Link } from 'react-router-dom'
import { BsFillLockFill } from 'react-icons/bs'
import { useOnClickOutside } from '../../../hooks/useOnClickOutside'

const Index = ({ data, setIsSearch, isSearch }) => {

    const [state, setState] = useState('')
    const searchRef = useRef(null)

    const handleClick = () => {
        setIsSearch('')
        setState('')
    }

    const normalizeData = (data) => {
        const result = [];

        const processItems = (items) => {
            for (const item of items || []) {
                if (!item?.hasOwnProperty('menu')) {
                    result.push(item);
                } else {
                    processItems(item.menu);
                }
            }
        };

        processItems(data);
        return result;
    };

    const handleHoverOff = () => {
        setIsSearch(!isSearch);
    }

    useOnClickOutside(searchRef, handleHoverOff)

    return (
        <div className={styles.wrapper} ref={searchRef}>
            <input
                type='text'
                onChange={(e) => setState(e.target.value)}
                value={state}
                className={styles.input}
                placeholder='Поиск'
                autoFocus
            />

            <div className={styles.conteiner}>
                <div className={styles.menuList} >
                    {normalizeData(data)
                        ?.map((el, i) => {
                            if (el.label.toLowerCase().includes(state.toLowerCase()) && state.length > -1) {
                                if (el.link === '/') {
                                    return <span key={i} className={styles.link}>{el.label}
                                        <i className={styles.icon}><BsFillLockFill /></i>
                                    </span>
                                } else {
                                    return <Link key={i} to={el.link} onClick={handleClick} className={styles.link}>{el.label}
                                    </Link>
                                }
                            }
                        })}
                </div>
            </div>
        </div>
    )
}

export default Index